export const facebookHandle = "EcologiHQ";
export const instagramHandle = "ecologi_hq";
export const linkedInHandle = "ecologihq";
export const twitterHandle = "Ecologi_hq";
